import React, { Component } from 'react'
import UserHistoryList from 'components/organisms/user_history_list'

class UserHistory extends Component{
    render(){
        return (
            <>
                <UserHistoryList/>
            </>
        )
    }
}

export default UserHistory